import {Make} from "./data/types/makes/types";

export const DEFAULT_SELECTED_MAKE = {name: 'Ford', id: 50, no_approved_images_groups_count: null} as Make
export const ALL_MAKES_SELECT = {name: 'All makes', id: 0, no_approved_images_groups_count: null} as Make